<template>
	<div id="appbox">
		<div class="top_heard">

			<div class="top_box">
				<div class="logo_box">
					<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
				</div>
			
			<!-- 	<div class="top_search_box">
					<div class="top_search">
						<el-select v-model="top_search_url" size="small" class="top_search_type" placeholder="搜索类型">
						  <el-option
							v-for="item in options"
							:key="item.value"
							:label="item.label"
							:value="item.value"
							
							>
						  </el-option>
						</el-select>
						<input type="text" v-model="stitle" autocomplete="off" placeholder="搜索关键词……" class="el-input__inner"  style="border: 0px;width: 200px;height: 30px;">
						<img class="top_search_icon" src="../../../static/img/顶部搜素图标.png" @click="gotopsearch()" alt="" srcset="">
					</div>
					  
				</div> -->
				
			</div>
			<div class="top_tab_box">
				<div class="toptabnav">
						<el-menu
						  :default-active="activeIndex2"
						  class="el-menu-demo"
						  mode="horizontal"
						  @select="handleSelect"
						  router
						  background-color="#FE7C2B"
						  text-color="#FFFFFF"
						  active-text-color="#FFFFFF">
						<el-menu-item index="/Home">首页</el-menu-item>
						<el-menu-item index="/Newslist" >研学资讯</el-menu-item>
						<el-menu-item index="/Courselist" >研学课程</el-menu-item>
						<el-submenu index="/institution">
							<template slot="title">研学机构</template>
							<el-menu-item index="/Camplist" >研学营地</el-menu-item>
							<el-menu-item index="/Baselist" >研学基地</el-menu-item>
							<el-menu-item index="/traveler" >会员单位</el-menu-item> 
						  </el-submenu>
						
						<el-menu-item index="/Campmap" >研学地图</el-menu-item>
						<el-menu-item index="/Activitylist">活动中心</el-menu-item>
						<el-menu-item index="/Linelist" >研学线路</el-menu-item>
						<el-submenu index="/yanxueteam">
							<template slot="title">研学团队</template>
							<el-menu-item index="/mentorlist" >研学导师</el-menu-item>
							<el-menu-item index="/expertlist" >专家团队</el-menu-item>
						  </el-submenu>
						
						<!-- <el-menu-item index="/" >研学政策</el-menu-item> -->
					</el-menu>
				</div>
			<!-- 	<div class="top_banner">
					<el-carousel ref="carousel" :interval="4000"  height="550px">
					  <el-carousel-item v-for="item in platelist" :key="item">
						<h3 class="medium" style="width: 100%;height: 100%;"><img :src="item.thumb"  style="width: 100%;height: 100%;" alt="" srcset=""></h3>
					  </el-carousel-item>
					</el-carousel>
				</div>
				<div class="top_plate">
					<div class="plate_item" v-for="(plate, index) in platelist" :key="plate" @mouseover="showstep(index)" @click="goplate(plate.id)" >
						<div class="plate_icon">
							<img :src="plate.icon" alt="" srcset="">
						</div>
						<div class="plate_title">
							{{plate.title}}
						</div>
					</div>
				</div> -->
			</div>
		</div>
		<div class="register_box">
				<div class="register_main">
					<div class="register_step">
						<el-steps :active="stepid" :space="250" direction="horizontal" :align-center="true" finish-status="success">
						  <el-step title="扫码登录"></el-step>
						  <el-step title="登录成功"></el-step>
						</el-steps>
					</div>
					<div class="wxcode_img" v-if="wxdata.appid&&stepid==0">
						<div class="Login_title">
							请扫描二维码登录
						</div>
						<wxlogin
							href=""
							theme="black"
							:state="wxdata.state"    
							:appid="wxdata.appid"  
							scope="snsapi_login"
							:redirect_uri="encodeURIComponent(wxdata.redirect_uri)"
						></wxlogin>
						<div class="Login_tips">
							
						</div>
					</div>
					<div class="register_finality" v-if="stepid==1">
						<div class="register_finality_icon" >
							<img src="../../../static/img/完成.png" alt="" srcset="">
						</div>
						<div class="register_finality_title" >
							扫码登录成功
						</div>
						<div class="register_finality_button">
							<el-button type="success" @click="gohome()">返回首页</el-button>
						</div>
					</div>
				</div>
				
			</div>
			<el-dialog
			  title="您还未绑定手机号,绑定手机号完成账号注册"
			  :visible.sync="bindshow"
			  width="30%"
			  :before-close="onAgain"
			  :close-on-click-modal="false"
			  :close-on-press-escape="false"
			  :show-close="false"
			  center>
			  <el-form ref="form" :model="bindfrom"  label-width="100px">
				  <el-form-item label="手机端账号" prop="mobile">
				      <el-input v-model="bindfrom.mobile"></el-input>
				    </el-form-item>
					<el-form-item label="验证码" prop="captcha"  >
						<el-input  v-model="bindfrom.captcha" ></el-input>
						<el-button type="primary" color="#67C23A" style="margin-left: 10px;" v-if="CD" @click="putyzm()" >获取验证码</el-button>
						<el-button type="primary" color="#C0C4CC" style="margin-left: 10px;" v-else>重新发送{{second}}</el-button>
					</el-form-item>
					<el-form-item label="昵称" prop="nickName">
					   <el-input  v-model="bindfrom.nickName" ></el-input>
					</el-form-item>
				  <!-- <el-form-item > -->
				   <!-- </el-form-item> -->
			  </el-form>
			  <span slot="footer" class="dialog-footer" style="padding-top: 0px;">
				<el-popover
				  placement="top"
					v-model="showvisible"
				   trigger="manual">
				  <div class="verify-box">
				  	<slide-verify
				  	  ref="slideRef"
				  	  :l="42"
				  	  :r="10"
				  	  :w="280"
				  	  :h="280"
				  	  :imgs="images"
				  	  slider-text="向右滑动"
				  	  @success="onSuccess"
				  	  @fail="onFail"
				  	  @refresh="onRefresh"
				  	  @again="onAgain"
				  	>
				  	</slide-verify>
				  </div>
				  <el-button type="primary" slot="reference" @click="showvisible = true">绑定</el-button>
				</el-popover>
			    <!-- <el-button type="primary" @click="phonelogin()">登 录</el-button> -->
			  </span>
			</el-dialog>
			
		<div :class="tops?'navbar':'navbar-top'">
			     <el-tooltip class="item" effect="dark" content="返回首页" placement="left">
			             <a style="display: flex;flex-direction: column;justify-content: center; align-items: center;"  @click="gohome()"><i class="el-icon-s-home"></i>
									<div style="font-size: 14px;">首页</div></a>
			     </el-tooltip>
			     <div  class="qrShow3 right2"   v-if="showofficialQR">
						<img src="../../../static/img/gzhsuncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
					</div>
					
					<div  class="qrShow2 right2" v-if="showserviceQR">
						<img src="../../../static/img/客服码.png" style="width: 100px; height: 100px;border-radius: 8px;" />
					</div>
					<a style="display: flex;flex-direction: column;justify-content: center; align-items: center;" @mouseover="showserviceQRCode" @mouseleave="hideserviceQRCode"><i class="el-icon-service"></i>  
								
					    <div style="font-size: 14px;">客服</div></a>
			     <div  class="qrShow right" v-if="showQR">
								<img src="../../../static/img/suncode.jpg" style="width: 100px; height: 100px;border-radius: 8px;" />
			     </div>
			   
			         
			     <el-tooltip class="item" effect="dark" content="返回顶部" placement="left" v-if="tops">
			         <a @click="gotop"><i class="el-icon-caret-top"></i>
			         <br>
			         <span>顶部</span></a>
			     </el-tooltip>
			 </div>
			<div class="pagesbottom_box">
				<div class="subtexts">
					<div v-for="item in bottomnav" :key="item" @click="gobottomnav(item.type,item.linkurl)">{{item.title}}</div>
				</div>
				<div class="row">
					<div class="copy-left">
						<div class="bottom_logo">
							<img src="../../../static/img/logo.jpg" alt="" style="margin-top: 0px !important;"  height="" srcset="">
						</div>
						
					</div>
					<div class="bottom_right">
						<div class="bottom_msg">
							{{pcsetdata.foot}}
						</div>
						<div class="bottom_msg">
							<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">{{' '+pcsetdata.icp}}</a>
						</div>
						<div class="bottom_msg">
							课程适用人群:学生群体
						</div>
					</div>
					
				</div>
			</div>
		</div>
	
</template>

<script>
		import wxlogin from 'vue-wxlogin';
import { mapState, mapMutations } from 'vuex'
import {  getPc,getbottomnav,getcodepre,loginget,bindphone,yzmsms} from '@/request/api'
import { Loading } from 'element-ui';
// import navTab from '../Navtab/navtab'
	
export default {
  name: "Home",
    // components: {
    //   navTab
    // },
	components: {
	    wxlogin   //和上面引入名称保持一致
			},
  data(){
	  return {
		  activeIndex2: '/Login',
		  manage_url:'/',
		  manageoptions:[
		  	{
		  	  value: '/',
		  	  label: '管理入口'
		  	}, {
		  	  value: 'https://yxwy.wanjiaxiao.cn/',
		  	  label: '机构管理后台'
		  	},
		  	 {
		  		value:'http://xh.wanjiaxiao.cn/seeyon/index.jsp',
		  		 label: '研学OA平台'
		  	 }
		  ],
		pcsetdata:{},
		bottomnav:[],
		stepid:0,
		wxdata:{
			
		},
		//绑定弹窗
		bindfrom:{
			openid:'',
			unionid:'',
			mobile:'',
			nickName:'',
			 captcha:'',
		},
		bindshow:false,
		//滑块验证码
		images: [
			require('../../../static/img/滑块1.jpg'),
			require('../../../static/img/滑块2.jpg'),
			require('../../../static/img/滑块3.jpg')
		],
		tipsMsg:'',
		isSuccess: true,
		showvisible:false,
		//验证码按钮
		second: 60,
		CD:true,
	  }
  },
  beforeCreate(){
	   const loading = this.$loading({
			lock: true,
			text: '页面载入……',
			// spinner: 'el-icon-loading',
			background: '#ffffff'
		  });
  },
  created() {
	  this.getpcset()
  },
  mounted() {
	   const { code,state } = this.$route.params;
	   this.code=code||''
	   this.state=state||''
	   if(code){
		   var data={
			   code,
			   state
		   }
		   this.loginget(data)
		    this.stepid=1
	   }
	  // const { id } = this.$route.query;
	  // this.uuid = id
	// this.getlessonlist()
	this.getcodepre()
	 this.getbottomnav()
	window.addEventListener('scroll', this.scrollToTop)
 		
 },
  destroyed () {
         window.removeEventListener('scroll', this.scrollToTop)
   },
  beforeDestroy(){
	
  },
  methods: {
	  manageurl(e){
	  		  console.log('Site',e)
	  		  if(e!='/'){
	  			   window.open(e) 
	  		  }
	  		this.manage_url='/'
	  		  // window.location.href = e;
	  		  
	  },
	  phonebind(){
	  			  var data=this.bindfrom
	  			  var that=this
	  			  if(this.bindfrom.mobile==''){
	  						this.$alert('请输入登录手机号', '请输入登录手机号', {
	  							confirmButtonText: '确认',
	  							callback: action => {
	  								
	  							}
	  						});
	  				return;
	  			  }
	  			  if(this.bindfrom.mobile.length!=11){
	  						this.$alert('手机号长度位数错误', '手机号长度错误', {
	  							confirmButtonText: '确认',
	  							callback: action => {
	  								
	  							}
	  						});
	  				return;
	  			  }
	  			  if( this.bindfrom.nickName==''){
	  						this.$alert('请设置昵称', '存在未填项', {
	  							confirmButtonText: '确认',
	  							callback: action => {
	  								
	  							}
	  						});
	  				return;
	  			  }
				  if( this.bindfrom.captcha==''){
						this.$alert('请填写验证码', '存在未填项', {
							confirmButtonText: '确认',
							callback: action => {
								
							}
						});
						return;
				  }
	  			  bindphone(data).then(res=>{
	  				  if(res.data.code==200){
						  if(res.data.data.flag==1){
							  localStorage.setItem('token', res.data.data.token)
							  localStorage.setItem('refreshToken', res.data.data.refreshToken)
							  this.$alert('点击确定立刻登录', '绑定成功', {
							  	confirmButtonText: '确认',
							  	callback: action => {
							  		that.gohome()
							  	}
							  });
							
							  
						  }
					  }
	  	
	  				  // this.$router.go(0)
	  			  })
	  },
	  timer() {
	    let promise = new Promise((resolve, reject) => {
	      let setTimer = setInterval(
	        () => {
	            this.second= this.second - 1;
	          if (this.second <= 0) {
	              this.second= 60;
	              this.send=true
	            resolve(setTimer)
	          }
	        }
	        , 1000)
	    })
	  		promise.then((setTimer) => {
	  			this.CD=true;
	  		    clearInterval(setTimer)
	  		  })
	  		},
	  		putyzm(e){
	  		  var data={
	  		    mobile:this.bindfrom.mobile
	  		  }
	  		  if(this.bindfrom.mobile==''){
	  			this.$alert('请输入手机号，然后发动验证码', '请输入手机号', {
	  				confirmButtonText: '确认',
	  				callback: action => {
	  					
	  				}
	  			});
	  		    return;
	  		  }
	  		  console.log(this.bindfrom.mobile.length)
	  		  if(this.bindfrom.mobile.length!=11){
	  			this.$alert('手机号长度位数错误', '手机号长度错误', {
	  				confirmButtonText: '确认',
	  				callback: action => {
	  					
	  				}
	  			});
	  		    return;
	  		  }
	  		  this.CD=false;
	  		  this.timer();
	  		  yzmsms(data).then(res=>{
	  			   console.log(res)
	  		  })
	  		},
	  // 成功回调
	    onSuccess(){
	  	  this.tipsMsg = '恭喜您，验证成功啦！';
	  	  this.isSuccess = true;
	  			  this.showvisible=false
	  			  this.phonebind()
	  			  this.$refs.slideRef.reset();
	    },
	    
	    // 失败回调
	    onFail(){
	  	  this.tipsMsg = '验证失败，请重试哦！';
	  	  this.isSuccess = false;
	    },
	    // 点击刷新回调
	    onRefresh(){
	  	  this.tipsMsg = ''
	    },
	    // 刷新成功后回调
	    onRefreshComplete(){
	  			  this.tipsMsg = ''
	  			  this.isSuccess = true;
	    },
	    // 检测到非人为操作
	    onAgain() {
	  			  
	  			this.$refs.slideRef.reset();
	  			 this.showvisible=false
	  			this.bindshow=false
	    },
	  loginget(data){
			loginget(data).then(res=>{
				console.log(res.data)
				if(res.data.data.flag==0){
					this.bindfrom.openid=res.data.data.data.openid
					this.bindfrom.unionid=res.data.data.data.unionid
					this.bindshow=true
				}
				if(res.data.data.flag==1){
					  localStorage.setItem('token', res.data.data.token)
					  localStorage.setItem('refreshToken', res.data.data.refreshToken)						  
				}
			})
	  },
	  goregister(e){
	  			  this.$router.push({
	  			    path: "/register",
	  			    name: "/register",
	  			  		  query: {
	  			  		  }
	  			  });
	  },
	  next(){
	    if (this.stepid <2){
	  	  this.stepid=this.stepid+1
	    }
	  },
	  getcodepre(){
			var data={
				pre:''
			}  
			getcodepre(data).then(res=>{
				console.log(res)
				this.wxdata=res.data.data
			})
	  },
	  getbottomnav(){
	  		  var data={
	  			  page_index:1,
	  			  page_size:15,
					flag:99
	  		  }
	  		getbottomnav(data).then(res=>{
	  			this.bottomnav=res.data.data.list
	  		})  
	  },
	  gobottomnav(type,link){
	  		  if(type==1){
	  			  this.$router.push({
	  			  	path:link
	  			  });
	  		  }else if(type==2){
			  window.location.href = link;
		  }
	  },
	  logout(){
		var that=this
		this.$confirm('是否确认退出登录?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
		}).then(() => {
				this.$alert("已退出登录", '', {
					confirmButtonText: '确认',
					callback: action => {
						localStorage.setItem('token', '')
						localStorage.setItem('refreshToken', '')
						 that.$router.go(0)
					}
				  });
		}).catch(() => {
			 
		});
	  },
	  showofficialQRCode(){
		  		 this.showofficialQR=true
		  },
		  hideofficialQRCode(){//隐藏二维码
		      this.showofficialQR = false
		  },
		  showserviceQRCode(){
	  			  this.showserviceQR=true
	  },
	  hideserviceQRCode(){//隐藏二维码
	      this.showserviceQR = false
	  },
	  showQRCode(){//显示二维码
		  this.showQR = true
	  },
	  hideQRCode(){//隐藏二维码
		  this.showQR = false
	  },
	  scrollToTop () {
		  let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
		  this.scrolltop = scrollTop
		  if (parseInt(this.scrolltop) > (parseInt(this.heights) / 3)) {
			  this.tops = true
		  } else {
			  this.tops = false
		  }
	  },
	  gotop () {
		  let timer = setInterval(() => {
			  document.documentElement.scrollTop = document.body.scrollTop = this.scrolltop - 90
			  if (this.scrolltop === 0) {
				  clearInterval(timer)
			  }
		  }, 15)
	  },
	  timer() {
	    let promise = new Promise((resolve, reject) => {
	      let setTimer = setInterval(
	        () => {
	            this.second= this.second - 1;
	          if (this.second <= 0) {
	              this.second= 60;
	              this.send=true
	            resolve(setTimer)
	          }
	        }
	        , 1000)
	    })
	  		promise.then((setTimer) => {
	  			this.CD=true;
	  		    clearInterval(setTimer)
	  		  })
	  		},

	  showphonebox(){
	  		this.phoneboxshow=true  
	  },
	  closephonebox(){
	  		this.phoneboxshow=false  
	  },
	  gohome(e) {
	    this.$router.push({
	      path: "/Home",
	      name: "/Home",
	  			  query: {
	  			  }
	    });
	  },
	  handleRemove(file, fileList) {
		  console.log(file, fileList);
		},
		handlePictureCardPreview(file) {
		  this.dialogImageUrl = file.url;
		  this.dialogVisible = true;
		},
	  register_typechange(e){
		this.register_type=e  
	  },
	  resetting(){
		this.stepid=0
		this.register_searchtype=false
		this.ruleForm={
			  mobile: '',
			  nickName: '',
			  password: '',
			  repassword: '',
			  unionid:'',
			  openid:'',
			  captcha:'',
			  is_pc:1,
			}
		this.campmsg={}
		this.camplist=[]
			
	  },
		next(){
		  if (this.stepid <2){
			  this.stepid=this.stepid+1
		  }
		},
	   showstep(ind) {
	        this.$refs.carousel.setActiveItem(ind)
	      },
		  goplate(id){
			  
		  },
	  getPlate(){
		var data={
			flag:99
		}  
		getPlate(data).then(res=>{
			this.platelist=res.data.data
		})
	  },
	  
	  changementor(e){
		console.log('1112',e)  
		this.mentorindex=e+1
		this.getmentor()
	  },
	  mentoropen(index){
		this.mentor_index=index  
	  },
	  relist(data){
		  const list = data.split(',');
		  return list
	  },
	  
	  getpcset(){
		var data={
				flag:99
			}
		getPc(data).then(res=>{
			this.pcsetdata=res.data.data
		})  
		const loading = this.$loading({
		         lock: true,
		         text: 'Loading',
		         spinner: 'el-icon-loading',
		         background: 'rgba(0, 0, 0, 0.7)'
		       });
		loading.close();
	  },
	 
	  camptypetab(val){
	  			  // this.lessoncategory_id=val
	  			  this.getlessonlist()
	  },
	 
	  
	  newshandleClick(e){
			console.log(e,this.category_id)
			this._getNewslist()
	  },
	  
	  
	handleSelect(key, keyPath) {
		console.log(key, keyPath);
	},
	golist(e){
		this.$router.push({
		  path: "/"+e,
		  name:"/"+e,
			query: {
			}
		});
	},
	
  }
};
	
</script>

<style scoped>
	.Login_title{
		font-size: 20px;
	}
	::v-deep .wrp_code img{
		width: 100% !important;
		margin-top: 0 !important;
	}
	.reset_title{
		    width: 100%;
		    text-align: left;
		    font-size: 22px;
		    font-weight: 600;
		    margin-bottom: 10px;
	}
	.reset_tips{
		    text-align: left;
		    font-size: 16px;
		    color: #909399;
	}
	.form_msgbox{
		flex:1;
		font-size:14px ;
	}
	.msgbox_item{
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		color: #303133;
	}
	.formmsg_title{
		/* width: 110px; */
		text-align: left;
		
		font-weight: 600;
	}
	.frommsg_text{
		color: #909399;
	}
	.register_finality_icon{
		width: 200px;
		height: 200px;
		
	}
	.register_finality_icon img{
		width: 100%;
		height: 100%;
	}
	.register_finality{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.register_finality_title{
		font-size: 24px;
		    color: #333;
		    font-weight: 500;
		    margin-top: 30px;
	}
	.register_finality_subtitle{
		font-size: 18px;
		    color: #666;
		    margin-top: 20px;
			display: flex;
			align-items: center;
	}
		
	.register_finality_subtitle a{
		 color: #FE7C2B !important;
	}
	.register_finality_button{
		text-align: center;
		    margin-top: 50px;
	}
	.register_box{
		width: 100%;
		padding: 50px 0;
		background: #e3fce9;
	}
	.register_main{
		background-color: #fff;
		width: 850px;
		margin: auto;
		padding: 50px 30px 30px;
		border-radius: 15px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}
	.register_step{
/* 		    display: flex;
		   text-align: center;
		    justify-content: space-between; */
		    padding: 20px 50px 50px;
		    border-bottom: 1px solid #e9e9e9;
		    margin-bottom: 40px;
	}
	.register_main1{
		    display: flex;
		    text-align: center;
		    justify-content: space-between;
		    border-bottom: 1px dashed #e9e9e9;
		    padding: 0 50px 40px;
		    margin-bottom: 30px;
	}
	.register_type{
		border: 1px solid #e9e9e9;
		    padding: 20px 10px;
		    border-radius: 10px;
		    width: 100px;
		    color: #333;
		    position: relative;
		    cursor: pointer;
	}
	.checkiconbox{
		font-size: 21px;
		position: absolute;
		right: -1px;
		top: -1px;
		background-color: #fff;
		border: 1px solid #72eb62;
		border-radius: 0 10px 0 5px;
		height: 25px;
		width: 30px;
		display: block;
		color: #259117;
		font-style: normal;
		-webkit-font-smoothing: antialiased;
	}
	.register_tipsbox{
		    padding: 10px 50px 0;
	}
	.register_tips{
		    display: flex;
		    padding: 5px 0;
			font-size: 14px;
		    color: #666;
	}
	.register_tips_title{
		width: 80px;
		    color: #333;
		    font-weight: 600;
	}
	.register_tips_text{
		flex: 1;
		text-align: left;
	}
	.slsicon{
		    border: 1px solid #72eb62;
		    color: #259117;
		    background-color: #e7fee4;
	}
	.type_title{
		    font-size: 18px;
		    font-weight: 400;
			margin-block-start: 0.83em;
			    /* margin-block-end: 0.83em; */
			margin-inline-start: 0px;
			margin-inline-end: 0px;
	}
	.form_tips{
		width: 350px !important;
		position: relative;
		display: flex;
		padding: 9px 0!important;
		line-height: 20px;
		margin-right: 10px;
		color: #999!important;
		text-align: left;
		margin-left: 10px;
	}
	.register_buttonbox1{
		margin-top: 20px;
		position: relative;
		text-align: center;
		padding: 5px 0 10px;
		margin-bottom: 15px;
		clear: both;
		margin: 0;
		
	}
	.register_buttonbox1 button{
		    height: 44px;
		    line-height: 44px;
		    padding: 0 25px;
		    font-size: 16px;
	}
	.home_banner_text{
		width: 100%;
		    padding: 4px 0;
		    background: rgba(71,86,105,.51);
		    color: #fff;
		    text-align: center;
		    position: absolute;
		    bottom: 0;
		    height: 18px;
		    line-height: 18px;
		    font-size: 14px;
	}
	body{
		background: #ffffff;
	}
	#appbox{
		background: #ffffff;
	}
	.Home_column1{
		width: 1180px;
		display: flex;
		margin: 0 auto;
		justify-content: space-between;
		margin-top: 50px;
	}
	.Home_column2{
		width: 1180px;
		margin: 0 auto;
		margin-top: 20px;
	}
	.column_titlebox{
		width: 100%;
		padding: 20px 0px;
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
	}
	.column_title{
		font-size: 22px;
		color: #FE7C2B;
	}
	.column_right{
		display: flex;
		align-items: flex-end;
		
	}
	.column_right:first-child {
		 border-left: 0px !important;
	  /* 父元素的第一个子元素的样式 */
	}
	.mentor_type{
		padding: 0px 10px;
		font-size: 16px;
		border-left: 1px solid #606266;
		color:#606266 ;
	}
	.gomore_mentor{
		margin-left: 20px;
		font-size: 14px;
		color:#606266 ;
	}
	.column_gomore{
		text-align: right;
		font-size: 16px;
		color: #C0C4CC;
	}
	.column2_box{
		width: 100%;
	
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
	}
	.column_blockimg{
		width: 285px;
		 box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}
	
	.product_box{
		width: 1180px;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid #EBEEF5;
		padding: 15px 0px;
		border-radius: 5px;
		/* height: ; */
	}
	.prodduct_item{
		width: 195px;
		height: 60px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		border-left: 1px solid #EBEEF5;
	}
		
	.prodduct_title{
		padding: 4px 10px;
		border-radius: 10px;
		margin-bottom: 4px;
		font-size: 18px;
		font-weight: 600;
		color: #303133;
	}
	.product_msg{
		font-size: 14px;
		color: #909399;
	}
	
	.mentor_item{
		padding: 20px;
		width: 330px;
		display: flex;
		align-items: center;
		background: #f9f9f9;
		border-radius: 8px;
	}
	.mentor_imgs{
		width:100px;
		height: 135px;
	}
	.mentor_imgs img{
		border-radius: 5px;
		width: 100%;
		height: 100%;
	}
		
	.mentor_msgbox{
		margin-left: 20px;
		flex: 1;
		display: flex;
		flex-direction: column;
		
	}
	.mentor_title{
		font-size: 18px;
		font-weight: 600;
		color: #303133;
		text-align: left;
	}
	.mentor_subtitle{
		font-size: 15px;
		color: #909399;
		margin: 10px 0px;
		text-align: left;
	}
	.mentor_msg{
		font-size: 12px;
		color: #909399;
		margin: 1px;
		text-align: left;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		
	}
	.Traveler_item{
		padding: 20px;
		width: 340px;
		background: #f9f9f9;
		border-radius: 8px;
	}
	.Traveler_title{
		width: 100%;
		font-size: 18px;
		color: #303133;
		text-align: left;
		margin-bottom: 10px;
	}
	.Traveler_msg{
		width: 100%;
		font-size: 14px;
		color: #909399;
		text-align: left;
	}
	.prodduct_item{
		
	}
	.column2_item{
		width: 265px;
		height: 260px;
		border-radius: 15px;
		position: relative;
	}
	.camp_rank{
		position: absolute;
		left: 0px;
		top: 0px;
		padding: 4px 8px;
		font-size: 14px;
		border-radius: 10px 0px;
		    background: #fe3113;
		    color: #ffffff;
	}
	.column2_img{
		width: 100%;
		height: 180px;
	}
	.column2_img img{
		width: 100%;
		height: 100%;
		border-radius:10px 10px 0px 0px;
	}
	.column2_title{
		padding: 10px;
		background: #f9f9f9;
		border-radius: 0px 0px 10px 10px;
		padding-bottom: 15px;
	}
	.item_title{
		font-size: 18px;
		font-weight: 600;
		color: #303133;
		margin-bottom: 15px;
		text-align: left;
		overflow: hidden;
		    white-space: nowrap;
		    text-overflow: ellipsis;
		/* text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical; */
	}
	.item_subtitle{
		font-size: 14px;
		color: #909399;
		text-align: left;
		overflow: hidden;
		    white-space: nowrap;
		    text-overflow: ellipsis;
	}
	
	
	.Home_imgs{
		width: 575px;
		
	}
	.newnews_box{
		width: 580px;
	}
	.news_top{
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: flex-end;
	}
	.news_title{
		padding: 15px;
		border-bottom: 2px solid #FE7C2B;
		color: #FE7C2B;
		font-size: 22px;
		font-weight: 600;
	}
	.news_gomroe{
		padding: 17px 0px;
		text-align: right;
		flex: 1;
		font-size: 16px;
		border-bottom: 1px solid #E4E7ED;
		color: #C0C4CC;
	}
	.newslist{
		width: 100%;
		display: flex;
		flex-direction: column;
		margin: 0px;
	}
	.news_item{
		text-align: left;
	}
	
	
	.plate_icon{
		width:70px;
		height: 70px;
	}
	.plate_icon img{
		width: 100%;
		width: 100%;
	}
	.plate_title{
		margin-top: 10px;
	}
	.plate_item{
		width: 340px;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		border-left: 1px solid #ffffff;
		color: #ffffff;
		font-size: 22px;
		font-weight: 600;
	}
	.plate_item:hover{
		background: #cccccc38;
	}
	.plate_item:active{
		background:#0f6a8f36;
	}
	 .plate_item:first-child {
		 border-left: 0px solid #ffffff;
	  /* 父元素的第一个子元素的样式 */
	}
	.plate_icon{
		
	}
	
	.top_minemsgbox{
		width: 1230px;
		padding:10px 0px;
		/* height: 110px; */
		display: flex;
		align-items: center;
		justify-content: flex-start;
		margin: 0 auto;
		font-size: 15px;
		color:#606266;
		/* padding: 120px; */
	}
	.welcome{
		color:#187192;
		font-size: 16px;
		margin:0px 40px;
		/* flex: 1; */
		text-align: left;
		margin-right: 200px;
		
	}
	.top_right{
		display: flex;
		align-items: center;
	}
	.top_Mobiletype{
		padding: 4px 15px;
		background: #FE7C2B;
		color: #ffffff;
		border-radius: 20px;
		margin-right: 10px;
		font-size: 14px;
	}
	.top_box{
		width: 1230px !important;
		justify-content: flex-start;
	}
	.logo_box{
		margin-right: 80px;
	}
	.top_gatebox{
		margin-right: 300px;
	}
	.top_search_box{
		display: flex;
		align-items: center;
	}
	.top_search{
		display: flex;
		align-items: center;
		border: 1.5px solid #FE7C2B;
		position: relative;
		padding: 6px 20px;
		border-radius: 60px;
		    margin: 0px 20px;
			font-size: 16px;
	}
	.top_search input{
		width: 300px;
		color:#747dce;
	}
	.top_search i{
		font-size: 20px;
		font-weight: 600;
		color: #C0C4CC;
	}
	.top_search_icon{
		width: 64px !important;
		height: 64px !important;
		object-fit:contain;
		position: absolute;
		right: -10px;
	}
	.toptabnav{
		height: 70px !important;
	/* 	background: #FE7C2B00;
		position: absolute; */
		z-index: 99;
	}
	.top_tab_box{
		width: 100%;
		position: relative;
	}
	.top_banner{
		
	}
	.top_plate{
		/* position: absolute; */
		/* bottom: 0px; */
		width: 100%;
		height: 164px;
		display: flex;
		justify-content: center;
		background: #FE7C2B;
		z-index: 99;
	}
	
	
	
	.el-tag--mini{
		font-size: 8px !important;
		    padding: 0 2.8px;
	}
	.mentor{
		width: 1100px;
		margin: 0 auto;
		margin-top: 20px;
		
	}
	.mentor_box{
		width: 1100px;
		display: flex;
		/* justify-content: ; */
		flex-wrap: wrap;
		
		background: #30313336;
	}
	.mentor_msg_box{
		position: absolute;
		width: 180px;
		height: 245px;
		background: #333333c7;
		color: #ffffff;
		top: 0px;
		    left: 0px;
	}
/* 	.mentor_title{
		padding:15px 10px;
		margin: 0px 10px;
		margin-top: 50px;
		font-size: 20px;
		font-weight: 500;
		border-bottom: 1px solid #ffffff;
	} */
	.mentor_tags{
		padding: 9px;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
		justify-content: space-between;
	}
	.mentor_camp{
		font-size: 14px;
		text-align: left;
		padding: 10px;
		padding-top: 0px;
	}
	.ntmain{
		width: 1000px;
	}
	.nttext:hover{
		color: #FE7C2B !important;
	}
	.ntbox{
		width: 1060px;
		    background: #ffffff;
		    margin: 10px auto;
		    display: flex;
		    align-items: center;
		    padding: 0px 20px;
	}
	.nticon{
		width: 30px;
		height: 30px;
		margin-right: 10px;
	}
	.el-carousel__item h3{
		opacity: 1 !important;
	}
	.lessonbox{
		width: 1100px;
		margin: 0 auto;
		margin-top: 20px;
	}
	.home_titlebox{
		width: 1100px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.next_text{
		margin-bottom: 20px;
		font-size: 16px;
	}
	.camplist{
		padding: 20px;
		width:1060px ;
		background: #ffffff;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: center;
	}
	.lessonlist{
		padding: 20px;
		width:1060px ;
		background: #ffffff;
		flex-wrap: wrap;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.actlist{
		padding: 20px;
		width:1060px ;
		background: #ffffff;
		flex-wrap: wrap;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.actmsgbox{
		width: 320px;
		padding: 10px;
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}
	.actbutton{
		width: 80px;
		height: 30px;
		line-height: 30px;
		font-size: 18px;
		color: #ffffff;
		background: #FE7C2B;
	}
	.actbutton2{
		width: 80px;
		height: 30px;
		line-height: 30px;
		font-size: 18px;
		color: #ffffff;
		background: #9e9e9e;
	}
	.actbox{
		width: 1100px;
		margin-top: 20px !important;
		margin: 0 auto;
	}
	.campitem{
		width: 340px;
		border-radius: 8px;
			color: #333;
	}
	.lessonitem{
		width: 257px;
		margin-bottom: 10px;
		color: #333;
	}
	.lessonitem:hover{
		color: #FE7C2B;
	}
	.campitem:hover{
		color: #FE7C2B;
	}
	.lessonimgbox{
		width: 257px;
		height: 177px;
		position: relative;
	}
	.lessonimgbox img{
		width: 100%;
		height: 100%;
	}
	.campimgbox{
		width: 340px;
		height: 168px;
		position: relative;
		
	}
	.actimgbox{
		width: 340px;
		height: 218px;
	}
	.actimgbox img{
		width: 100%;
		height: 100%;
	}
	.actpay{
		font-size: 14px;
		color: brown;
	}
	
	.campimgbox img{
		width: 100%;
		height: 100%;
		border-radius: 8px 8px 0px 0px;
	}
	.campaddress{
		width: 320px;
		position: absolute;
		bottom: 0;
		right: 0;
		z-index: 1;
		display: flex;
		justify-content: flex-end;
		align-items: flex-end;
		font-size: 12px;
		font-weight: 600;
		color: #ffffff;
		height: 26px;
		line-height: 26px;
		padding: 0 10px;
		background: #30313336;
	}
	.camptitle{
		padding: 10px;
		font-size: 18px;
		width: 320px;
		height: 46px;
	
		/* margin-bottom: 15px; */
		text-align: left;
		/* height: 50px; */
		/* line-height: 50px; */
		text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	.lessontitle{
		padding: 10px;
		font-size: 18px;
		width: 237px;
		height: 46px;
		text-align: left;
		text-overflow: ellipsis;
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	
	.imgsbox{
		/* width:1100px; */
		/* margin: 10px auto; */
	}
	.advbanner{
		width:1100px;
		margin: 0px auto;
	}
	.newsimgH{
		width: 210px;
		height: 135px;
		background-color: #333;
	}
	.newsitemH{
		width: 525px;
		padding: 10px;
		border-radius: 8px;
		display: flex;
		/* justify-content: ; */
		
		align-items: center;
		margin-bottom: 10px;
		background: #ffffff;
	}
	.newsitemH:hover{
		color: #FE7C2B;
	}
	.newsitembox{
		width: 100%;
		margin-top: 10px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-items: center;
	}
	.newsmsgH{
		width: 280px;
		height: 135px;
		margin-left: 20px;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: space-between;
	}
	.news_bottomH{
		width: 100%;
		display: flex;
		justify-content: space-between;
	}
	.newstitle{
		font-size: 18px;
		
	}
	.campbox{
		width: 1100px;
		margin: 0 auto;
	}
	::v-deep .el-tabs__header{
		margin: 0px !important;
	}
	::v-deep .el-tabs__item{
		font-size: 18px;
		height: 78px !important;
		line-height: 78px !important;
		/* padding:30px ; */
	}
	::v-deep .el-select>.el-input{
	width: 360px !important;
}
/* 	.el-tabs__content{
		background: #f5f5f5;
	} */
</style>

<style>
.el-form-item__content{
	display: flex;
	align-items: center;
}
.el-form-item__content>.el-input{
	/* width: 350px !important; */
	flex: 1;
}
.el-form-item__content>.el-input{
	/* width: 350px !important; */
	flex: 1;
}

</style>